import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PostingTimeGenerator.css';

const PostingTimeGenerator = () => {
  const [suggestions, setSuggestions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  const fetchSuggestions = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.get('/api/posting-time/suggest');
      if (response.data.success) {
        const parsed = JSON.parse(response.data.output);
        setSuggestions(parsed);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch suggestions');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuggestions();
  }, []);

  const handleCopy = () => {
    if (suggestions) {
      const text = `Best Days: ${suggestions.bestDays.join(', ')}\n\nBest Times:\n${suggestions.bestTimes.map(t => `- ${t.time}: ${t.reason}`).join('\n')}\n\nTips:\n${suggestions.tips.map(t => `- ${t}`).join('\n')}\n\n${suggestions.explanation}`;
      navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="generator-container">
      <div className="generator-header">
        <h2>Best Posting Time Suggestion</h2>
        <p className="generator-description">
          Get data-driven recommendations for the best times to post on LinkedIn for maximum engagement.
        </p>
      </div>

      <div className="posting-time-content">
        {error && <div className="error-message">{error}</div>}
        
        {loading ? (
          <div className="loading">Loading suggestions...</div>
        ) : suggestions ? (
          <>
            <div className="output-actions">
              <button className="copy-button" onClick={handleCopy}>
                {copied ? '✓ Copied!' : 'Copy to Clipboard'}
              </button>
              <button className="refresh-button" onClick={fetchSuggestions}>
                Refresh
              </button>
            </div>

            <div className="suggestions-grid">
              <div className="suggestion-card">
                <h3>Best Days</h3>
                <ul>
                  {suggestions.bestDays.map((day, idx) => (
                    <li key={idx}>{day}</li>
                  ))}
                </ul>
              </div>

              <div className="suggestion-card">
                <h3>Best Times</h3>
                <ul>
                  {suggestions.bestTimes.map((time, idx) => (
                    <li key={idx}>
                      <strong>{time.time}</strong>
                      <span>{time.reason}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="suggestion-card full-width">
                <h3>Tips & Best Practices</h3>
                <ul>
                  {suggestions.tips.map((tip, idx) => (
                    <li key={idx}>{tip}</li>
                  ))}
                </ul>
              </div>

              <div className="suggestion-card full-width">
                <h3>Explanation</h3>
                <p>{suggestions.explanation}</p>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default PostingTimeGenerator;
